import {PayloadItemModel} from '../../../../../../../../core';
import {SearchEntity} from '../entity/search.models';

export class UpdatePayload extends PayloadItemModel<SearchEntity> {
}
